export const LOGIN_OK = 'LOGIN_OK';
export const LOG_OUT = 'LOG_OUT';
export const GET_USER = 'GET_USER';
export const SET_LOADING = 'SET_LOADING';